class GlobalFunctions {

    public static scrollToElement(id: string, duration: number): void {
        if (document.querySelector(id) == undefined) {
          //console.log("nothing to do here: "+id);
          return;
        }
        let elementY = window.pageYOffset + document.querySelector(id).getBoundingClientRect().top - 50;//-50 wg. fixed header!
        let startingY = window.pageYOffset;
        let diff = elementY - startingY;
        let start;
    
        // Bootstrap our animation - it will get called right before next frame shall be rendered.
        window.requestAnimationFrame(function step(timestamp) {
          if (!start) start = timestamp
          // Elapsed miliseconds since start of scrolling.
          let time = timestamp - start
          // Get percent of completion in range [0, 1].
          let percent = Math.min(time / duration, 1)
    
          window.scrollTo(0, startingY + diff * percent)
    
          // Proceed with animation as long as we wanted it to.
          if (time < duration) {
            window.requestAnimationFrame(step)
          }
        });
      }
}
export { GlobalFunctions };


// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/global-functions.ts